import React from "react";
import { ChevronRight } from "lucide-react";

import { useAppSelector } from "../../../app/store";
import {
  getAccountDetailByAccountNumber,
} from "../../creditAccounts/logic/slice";

import AssetClassificationPill from "../../accountDetails/components/AssetClassificationPill";


interface LinkedLoanAccountCardProps {
  accountNumber: string;
  onClick?: () => void;
}

const LinkedLoanAccountCard: React.FC<LinkedLoanAccountCardProps> = ({
  accountNumber,
  onClick,
}) => {
  const accountDetails = useAppSelector((state) =>
    getAccountDetailByAccountNumber(state, accountNumber),
  );

  if (!accountDetails?.account) {
    return null;
  }

  const { account, accountOverview } = accountDetails;

  const assetClassification =  accountOverview?.current_position?.asset_classification;

  return (
    <button
      type="button"
      onClick={onClick}
      className="
        flex
        w-full
        items-center
        justify-between
        rounded-[8px]
        bg-white
         p-2
        text-left
      "
    >
      <div className="flex min-w-0 flex-col gap-1">
        <span className="truncate text-[14px] font-normal leading-5 text-[#0A0A0A]">
          {account.ext_account_number || "--"}
        </span>

        <span className="truncate text-[12px] font-normal leading-4 text-[#737373]">
          {account.product || "--"}
        </span>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        <AssetClassificationPill value={assetClassification} />

        <ChevronRight
          size={16}
          className="text-[#737373]"
        />
      </div>
    </button>
  );
};

export default LinkedLoanAccountCard;